import clsx, { ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export const tw = (...inputs: ClassValue[]) => {
  return twMerge(clsx(inputs));
};

type KeyPressHandler = (
  key: string,
  action: () => void
) => (event: React.KeyboardEvent<HTMLInputElement>) => void;

export const handleKeyPress: KeyPressHandler = (key, action) => (event) => {
  if (event.key === key && !event.nativeEvent.isComposing) {
    action();
  }
};

export const handleOpenChatPopup = () => {
  const width = 660;
  const height = 900;

  const left = window.screenX + (window.outerWidth - width) / 2;
  const top = window.screenY + (window.outerHeight - height) / 2;

  window.open(
    `/chatting`,
    `Chatting Popup`,
    `width=${width}, height=${height}, left=${left}, top=${top}, popup`
  );
};
